const endsWithDuaSuffix = (name: string) => {
  const lowered = name.trim().toLocaleLowerCase('tr-TR')
  return (
    lowered.endsWith('duası') ||
    lowered.endsWith('duasi') ||
    lowered.endsWith('duaları') ||
    lowered.endsWith('dualari')
  )
}

export const formatDuaTitle = (name: string | undefined) => {
  if (!name) return ''
  const trimmed = name.trim()
  return endsWithDuaSuffix(trimmed) ? trimmed : `${trimmed} Duası`
}

export const formatDuaGenitive = (name: string | undefined) => {
  if (!name) return ''
  const trimmed = name.trim()
  return `${formatDuaTitle(trimmed)}nın`
}
